import { createContext } from 'react'


/**
 * @name IntegrationPartnerContext
 */
export default createContext()
